import { PlaylistItemData } from "./PlaylistItemData";
import { LookupSongFunction } from "../../common/LookupSongFunction";
import { generateId } from "../../common/UrlFriendlyNanoIdGeneration";
import { SongUb } from "../../gql/graphql";

class PlaylistData {
  public constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly belongsToCrew: string | undefined,
    private readonly tags: readonly string[] = [],
    private readonly items: PlaylistItemData[] = [],
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
    public readonly lastServerVersion: number,
    public readonly needsPush: boolean,
    public readonly isQrCodeScannedPlaylist: boolean,
    public readonly isRemoved: boolean,
  ) {}

  public static createNew(
    id: string = generateId(),
    belongsToCrew: string | undefined,
    tags: ReadonlyArray<string> = [],
    items: PlaylistItemData[] = [],
  ) {
    const timestamp = new Date();
    return new PlaylistData(
      id,
      "Playlist vom " + timestamp.toLocaleString(),
      belongsToCrew,
      tags.concat(PlaylistData.createTimestampTag(timestamp)),
      items,
      new Date(),
      new Date(),
      0,
      true,
      false,
      false,
    );
  }

  private static createTimestampTag(timestamp: Date): string {
    return (
      timestamp.getFullYear() +
      "/" +
      (timestamp.getMonth() + 1) +
      "/" +
      timestamp.getDate()
    );
  }

  get titleLowercase(): string {
    return this.title.toLowerCase();
  }

  public getTags() {
    return structuredClone(this.tags);
  }

  public copyWithTitle(title: string) {
    return new PlaylistData(
      this.id,
      title,
      this.belongsToCrew,
      structuredClone(this.tags),
      structuredClone(this.items),
      this.createdAt,
      new Date(),
      this.lastServerVersion,
      true,
      this.isQrCodeScannedPlaylist,
      this.isRemoved,
    );
  }

  public copyWithIsRemoved(isRemoved: boolean): PlaylistData {
    return new PlaylistData(
      this.id,
      this.title,
      this.belongsToCrew,
      structuredClone(this.tags),
      structuredClone(this.items),
      this.createdAt,
      new Date(),
      this.lastServerVersion,
      true,
      this.isQrCodeScannedPlaylist,
      isRemoved,
    );
  }

  public copyWithItems(items: PlaylistItemData[]) {
    return new PlaylistData(
      this.id,
      this.title,
      this.belongsToCrew,
      structuredClone(this.tags),
      items,
      this.createdAt,
      new Date(),
      this.lastServerVersion,
      true,
      this.isQrCodeScannedPlaylist,
      this.isRemoved,
    );
  }

  public getItems(): PlaylistItemData[] {
    return this.items;
  }

  public getAllValidSongEntries(
    lookupSong: LookupSongFunction,
  ): readonly SongUb[] {
    const validEntries: SongUb[] = [];
    this.items.forEach((v) => {
      const song = lookupSong(v.songEntryId);
      if (song) validEntries.push(song);
    });
    return validEntries;
  }
}

export default PlaylistData;
